import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import Input from "../../components/UI/Input/Input";
import Button from "../../components/UI/Button/Button";
import Spinner from "../../components/UI/Spinner/Spinner";
//import classes from "./Auth.css";
import * as actions from "../../store/actions/index";
import { updateObject, checkValidity } from "../../shared/utility";
import "./Auth.css";
const logoIcon = require("../../styles/img/logo-2_new.png");

class Auth extends Component {
  state = {
    controls: {
      email: {
        elementType: "input",
        elementConfig: {
          type: "text",
          autoFocus: true,
          //placeholder: "Mail Address"
        },
        value: localStorage.tempuser !== "" && localStorage.tempuser !== undefined?localStorage.tempuser: "",
        validation: {
          required: true,
          isEmail: true,
        },
        valid: false,
        touched: false,
      },
      password: {
        elementType: "input",
        elementConfig: {
          type: "password",
          //placeholder: "Password"
        },
        value: localStorage.tempuser !== "" && localStorage.tempuser !== undefined?localStorage.tempuser: "",
        validation: {
          required: true,
          minLength: 6,
        },
        valid: false,
        touched: false,
      },
    },
    isKhidmatGuzar: true,
    validationerror: "",
    isCleared: false,
    loading: false,
  };

  componentDidMount() {
    if(localStorage.temptoken !=='' && localStorage.temptoken !== undefined)
    {
    this.ssosubmitHandler();
    }
    if (this.props.authRedirectPath !== "/") {
      this.props.onSetAuthRedirectPath();
    }
  }

  inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(this.state.controls, {
      [controlName]: updateObject(this.state.controls[controlName], {
        value: event.target.value,
        valid: checkValidity(
          event.target.value,
          this.state.controls[controlName].validation
        ),
        touched: true,
      }),
    });
    this.setState({ controls: updatedControls });
  };

  ssosubmitHandler = () => {
    //event.preventDefault();
    this.setState({ isCleared: false });
    if (this.state.controls["email"].value.trim() === "") {
      this.setState({ validationerror: "Username/ITS required" });
    } else if (this.state.controls["password"].value.trim() === "") {
      this.setState({ validationerror: "Password required" });
    } else {
      this.setState({ validationerror: "", loading: true });
      this.props.onAuth(
        this.state.controls.email.value,
        this.state.controls.password.value,
        this.state.isKhidmatGuzar
      );
    }
  };

  submitHandler = (event) => {
    event.preventDefault();
    this.setState({ isCleared: false });
    if (this.state.controls["email"].value.trim() === "") {
      this.setState({ validationerror: "Username/ITS required" });
    } else if (this.state.controls["password"].value.trim() === "") {
      this.setState({ validationerror: "Password required" });
    } else {
      this.setState({ validationerror: "", loading: true });
      this.props.onAuth(
        this.state.controls.email.value,
        this.state.controls.password.value,
        this.state.isKhidmatGuzar
      );
    }
  };

  checkboxHandler = () => {
    this.setState((prevState) => {
      return { isKhidmatGuzar: !prevState.isKhidmatGuzar };
    });
  };
  clearDataHandler = () => {
    const cleardata = updateObject(this.state.controls, {
      email: updateObject(this.state.controls["email"], {
        value: "",
        touched: false,
      }),
      password: updateObject(this.state.controls["password"], {
        value: "",
        touched: false,
      }),
    });
    this.setState({
      controls: cleardata,
      isKhidmatGuzar: true,
      validationerror: "",
      isCleared: true,
    });
  };

  render() {
    let AuthLoading = <Spinner />;
    let errorMessage = null;
    if (this.state.validationerror.trim() !== "") {
      errorMessage = (
        <p style={{ color: "red" }}>{this.state.validationerror}</p>
      );
    }
    // if(this.state.loading == true)
    // {
    //   this.setState({loading:this.props.loading})
    // }
    if (
      this.props.error &&
      this.state.validationerror.trim() === "" &&
      !this.state.isCleared
    ) {
      errorMessage = <p style={{ color: "red" }}>{this.props.error}</p>;
    }

    let authRedirect = null;
    if (this.props.isAuthenticated) {
      authRedirect = <Redirect to={this.props.authRedirectPath} />;
    }

    return (
      <div className="loginPage h-100">
        <div className=" d-flex align-items-center  h-100">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-4">
                <div className="wrapper">
                <div className="logoImage ">
                    <div className="d-flex justify-content-center">
                      <img
                        className="align-self-center mr-2"
                        src={logoIcon}
                        alt=""
                      />
                    </div>
                  </div>

                  {authRedirect}
                  {errorMessage}
                  {this.props.loading ? AuthLoading : null}
                  <form onSubmit={this.submitHandler}>
                    <div className="selectUser">
                      <span className="label">Select User</span>
                      <div className="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          id="customRadioInline1"
                          name="customRadioInline1"
                          className="custom-control-input"
                          checked={this.state.isKhidmatGuzar}
                          onChange={this.checkboxHandler}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customRadioInline1"
                        >
                          Khidmatguzar
                        </label>
                      </div>
                      <div className="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          id="customRadioInline2"
                          name="customRadioInline1"
                          className="custom-control-input"
                          checked={!this.state.isKhidmatGuzar}
                          onChange={this.checkboxHandler}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customRadioInline2"
                        >
                          Staff
                        </label>
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Username/ITS</label>
                      <Input
                        key={"email"}
                        classType="form-control usrimg"
                        elementType={this.state.controls["email"].elementType}
                        elementConfig={
                          this.state.controls["email"].elementConfig
                        }
                        value={this.state.controls["email"].value}
                        invalid={!this.state.controls["email"].valid}
                        shouldValidate={this.state.controls["email"].validation}
                        touched={this.state.controls["email"].touched}
                        changed={(event) =>
                          this.inputChangedHandler(event, "email")
                        }
                      />
                    </div>
                    <div className="form-group mt-4">
                      <label htmlFor="exampleInputPassword1">Password</label>
                      <Input
                        key={"password"}
                        classType="form-control pswdimg"
                        elementType={
                          this.state.controls["password"].elementType
                        }
                        elementConfig={
                          this.state.controls["password"].elementConfig
                        }
                        value={this.state.controls["password"].value}
                        invalid={!this.state.controls["password"].valid}
                        shouldValidate={
                          this.state.controls["password"].validation
                        }
                        touched={this.state.controls["password"].touched}
                        changed={(event) =>
                          this.inputChangedHandler(event, "password")
                        }
                      />
                    </div>
                    {/* {form} */}
                    <div className="text-center mt-4">
                      <Button classType="btn">Login</Button>
                      <button
                        type="button"
                        onClick={this.clearDataHandler}
                        className="btn btn-bordered ml-2"
                      >
                        Clear
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    //buildingBurger: state.burgerBuilder.building,
    authRedirectPath: state.auth.authRedirectPath,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: (email, password, isKhidmatGuzar) =>
      dispatch(actions.auth(email, password, isKhidmatGuzar)),
    onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath("/")),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
